import { COPY } from '../constants'
import { FormError, Props } from '../form-error'

export const SomethingWentWrongFormError = (props: Omit<Props, 'children' | 'title'>) => (
  <FormError {...props} title={COPY.somethingWentWrong.title}>
    {COPY.somethingWentWrong.message}
  </FormError>
)
